<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>{{title}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close"></i>
        </button>
      </div>
      <ng-content></ng-content>
      <div class="buttons-container">
        <button class="copy-btn vox-btn vox-btn-primary" (click)="copy()" type="button"
          translate>common.copy-link</button>
        <button class="vox-btn vox-btn-secondary-dark-grey" (click)="close()"
          translate>sales.copy-trial-link-modal.close</button>
      </div>
    </div>
  </div>
</div>
